interface MetricBoxProps {
  label: string;
  value: string;
  hint?: string;
}

export function MetricBox({ label, value, hint }: MetricBoxProps) {
  return (
    <div className="border border-border rounded-2xl p-3 bg-white/[.02] min-h-[74px]">
      <p className="text-xs text-muted font-mono mb-1.5">{label}</p>
      <p className="text-xl font-black tracking-tight">{value}</p>
      {hint && <p className="text-xs text-muted mt-1.5 leading-tight">{hint}</p>}
    </div>
  );
}
